<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content">

  <div class="imprint-content">
  <h2>{{getString("imprint")}}</h2>
  <h3>{{getString("infoAccordingTo")}}:</h3>
  <p>LollipApp GmbH<br />
    Ludwig-Erhard-Straße 30<br />
    63150 Heusenstamm
  </p>
  <h3>{{getString("representedBy")}}:</h3>
  <p>David Becker</p>
  <h3>{{getString("contact")}}:</h3>
  <table><tr>
  <td>{{getString("telephone")}}:</td>
  <td>06131-9064880</td></tr>
  <tr><td>{{getString("email")}}:</td>
  <td>info@lollipapp.com</td>
  </tr></table>
  <h3>{{getString("registerEntry")}}:</h3>
  <p>{{getString("entryInTradeRegister")}}. <br />{{getString("registrationOffice")}} <br />{{getString("registerNumber")}}</p>
  <h3>{{getString("VAT_id")}}:</h3>
  <p>{{getString("VAT_id_info")}}:<br />
  DE303617868</p>
  <h3>{{getString("responsibleForContent")}}:</h3>
  <p>David Becker<br />
    Ludwig-Erhard-Straße 303<br />
    63150 Heusenstamm</p>
  <h3>{{getString('contentAndCopyright')}}</h3>
  <p>{{getString('contentAndCopyrightText1')}}<br><br>
    {{getString('contentAndCopyrightText2')}}
    <a href="https://www.themoviedb.org/">TMDb</a><br>
    <img class="logo" src="./assets/images/tmdb.jpg">
  </p>
  <p>{{getString("source")}}: <em><a target="_blank" href="https://www.e-recht24.de">eRecht24</a></em></p>
  </div>

</div>
